const REQUIRED_ADDRESS_FIELDS = [
  'fullName',
  'email',
  'phone',
  'country',
  'countryId',
  'street',
  'houseNumber',
  'postalCode',
  'city',
];

const isNonEmptyString = (v) => typeof v === 'string' && v.trim().length > 0; // helper function to check if a value is a non empty string

export const isAddressComplete = (addr) => {
  if (!addr) return false;

  for (const key of REQUIRED_ADDRESS_FIELDS) {
    // go through all keys of REQUIRED_ADDRESS_FIELDS:
    const val = addr[key]; // get the address value for the current key
    if (!isNonEmptyString(String(val ?? ''))) return false; // make sure the value exists and is not empty
  }

  return true;
}; // function that checks if all required fields of an address exist and are not empty

const addressKeys = [
  'companyName',
  'fullName',
  'email',
  'phone',
  'country',
  'street',
  'houseNumber',
  'postalCode',
  'city',
];

export const isSameAddress = (shippingAddress, billingAddress) =>
  addressKeys.every(
    (key) => (shippingAddress?.[key] ?? '') === (billingAddress?.[key] ?? '')
  ); // this will compare the shippingAddress and billingAddress for each key. Is true, if all values are the same.

const cartIntegrityReasonKeyByReason = {
  deleted: 'place-order-screen-cart-integrity-design-deleted',
  'contains-user-uploaded-icons':
    'place-order-screen-cart-integrity-uploaded-icons',
  'missing-product': 'place-order-screen-cart-integrity-missing-product',
  'inactive-product': 'place-order-screen-cart-integrity-inactive-product',
  'restricted-product': 'place-order-screen-cart-integrity-restricted-product',
}; // maps backend cart integrity reasons to frontend translation keys

const getCartIntegrityReasonKey = (reason) => {
  if (reason?.startsWith('not-public')) {
    return 'place-order-screen-cart-integrity-design-not-public'; // handle not-public reasons even if the backend includes the current publicStatus
  }

  return (
    cartIntegrityReasonKeyByReason[reason] ||
    'place-order-screen-cart-integrity-error'
  ); // fall back to a generic cart error if the backend sends an unknown reason
};

export const getCartIntegrityReasonKeys = (invalid) => [
  ...new Set(invalid.map((inv) => getCartIntegrityReasonKey(inv.reason))),
]; // the translation keys for the invalid designs /api/designs/validate-for-purchase reports, deduplicated so the same message is only shown once

export const findShippingZone = (zones, countryId) => {
  const matchedZone = zones.find((zone) =>
    zone.countries.some((country) => country._id === countryId)
  );

  if (!matchedZone) return null;

  const matchedCountry = matchedZone.countries.find(
    (country) => country._id === countryId
  ); // Find the specific country within the matched zone

  return { zone: matchedZone, country: matchedCountry };
}; // the shipping zone that contains a country, and that country; null if no zone contains it

export const holidayConfirmationRequired = (holidayStatus) =>
  holidayStatus?.phase === 'pre-holiday' || holidayStatus?.phase === 'holiday'; // whether the checkout needs the customer's consent to the delayed processing: during the final 7 days before the holiday and during the holiday itself (PlaceOrderScreen reads it for the checkbox and again right before the PayPal order; PR 32)
